// src/redux/reducers/contractReducer.js
import {
    // Existing contract action types
    UPDATE_CONTRACT_CONTENT,
    SET_CONTRACT_DATA,
    SET_CONTRACT_LOADING,
    SET_CONTRACT_ERROR,
    SET_HIGHLIGHT_ERROR,
    RESET_CONTRACT,
    FETCH_CONTRACT_HISTORY_REQUEST,
    FETCH_CONTRACT_HISTORY_SUCCESS,
    FETCH_CONTRACT_HISTORY_FAILURE,
    ADD_HISTORY_ENTRY,
    FETCH_CONTRACT_ACTIVITY_REQUEST,
    FETCH_CONTRACT_ACTIVITY_SUCCESS,
    FETCH_CONTRACT_ACTIVITY_FAILURE,
    FETCH_CONTRACT_REQUEST,
    FETCH_CONTRACT_SUCCESS,
    FETCH_CONTRACT_FAILURE,
    SAVE_CONTRACT_REQUEST,
    SAVE_CONTRACT_SUCCESS,
    SAVE_CONTRACT_FAILURE,
    SHARE_CONTRACT_REQUEST,
    SHARE_CONTRACT_SUCCESS,
    SHARE_CONTRACT_FAILURE,
    DELETE_CONTRACTS_SUCCESS,
    DELETE_CONTRACTS_REQUEST,
    DELETE_CONTRACTS_FAILURE,
    FETCH_CONTRACTS_REQUEST,
    FETCH_CONTRACTS_SUCCESS,
    FETCH_CONTRACTS_FAILURE,
    FETCH_CONTRACTS_BY_TAB_REQUEST,
    FETCH_CONTRACTS_BY_TAB_SUCCESS,
    FETCH_CONTRACTS_BY_TAB_FAILURE,
    SET_TAB_TOTAL_COUNT,
    SET_CURRENT_TAB,
    SET_TAB_PAGE,
    SEARCH_CONTRACTS_REQUEST,
    SEARCH_CONTRACTS_SUCCESS,
    SEARCH_CONTRACTS_FAILURE,
    CREATE_CONTRACT_REQUEST,
    CREATE_CONTRACT_SUCCESS,
    CREATE_CONTRACT_FAILURE,

    // Chat message action types
    CONTRACT_MESSAGE_CLEAR,
    CONTRACT_MESSAGE_SET,
    CONTRACT_MESSAGE_ADD_USER,
    CONTRACT_MESSAGE_STREAM_UPDATE,
    CONTRACT_MESSAGE_STREAM_DONE,
    CONTRACT_MESSAGE_ERROR,

    // Conversation management types
    CLEAR_CHAT_REQUEST,
    CLEAR_CHAT_SUCCESS,
    CLEAR_CHAT_FAILURE,
    CREATE_CONTRACT_CONVERSATION_REQUEST,
    CREATE_CONTRACT_CONVERSATION_SUCCESS,
    CREATE_CONTRACT_CONVERSATION_FAILURE,
    CONTRACT_CHAT_UPDATE_MESSAGE,
    CONTRACT_CHAT_UPDATE_TOOLS,
    CONTRACT_CHAT_ADD_TOOL_EXECUTION,
    CONTRACT_CHAT_UPDATE_NODE_EXECUTION,
    CONTRACT_CHAT_UPDATE_PLAN,
    CONTRACT_CHAT_UPDATE_STEP_EXECUTION,
    CONTRACT_CHAT_UPDATE_SOURCES,
    CONTRACT_CHAT_UPDATE_METADATA,
    CONTRACT_CHAT_UPDATE_EDITS,
    CONTRACT_CHAT_UPDATE_EDIT_STATUS,
    CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTIONS,
    CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTION_STATUS,
    CONTRACT_CHAT_UPDATE_REVIEW_PROGRESS,
    RISK_ANALYSIS_RESET,
    RISK_ANALYSIS_ADD,
    RISK_ANALYSIS_ERROR,
    RISK_ANALYSIS_COMPLETE,
    RISK_ANALYSIS_REQUEST,
    SET_CURRENT_CONVERSATION_ID,
    UPDATE_CONTRACT_STATUS,
    UPDATE_CONTRACT_STATUS_SUCCESS,
    UPDATE_CONTRACT_STATUS_FAILURE,
    UPDATE_CONTRACT_COUNTRY_SUCCESS,
    REORDER_KANBAN_CONTRACTS,
    CLAUSES_REQUEST,
    CLAUSES_RESET,
    CLAUSES_ADD,
    CLAUSES_ERROR,
    CLAUSES_COMPLETE,
    SUGGESTED_CLAUSES_REQUEST,
    SUGGESTED_CLAUSES_RESET,
    SUGGESTED_CLAUSES_ADD,
    SUGGESTED_CLAUSES_ERROR,
    SUGGESTED_CLAUSES_COMPLETE,

    FILTER_CONTRACTS_REQUEST,
    FILTER_CONTRACTS_SUCCESS,
    FILTER_CONTRACTS_FAILURE,
    UPDATE_CONTRACT_OPTIMISTIC,

    // Contract Categories
    FETCH_CONTRACT_CATEGORIES_REQUEST,
    FETCH_CONTRACT_CATEGORIES_SUCCESS,
    FETCH_CONTRACT_CATEGORIES_FAILURE,
    RESTORE_CONTRACT_VERSION,

    // Key Info
    KEY_INFO_REQUEST,
    KEY_INFO_FETCH_SUCCESS,
    KEY_INFO_EXTRACT_REQUEST,
    KEY_INFO_EXTRACT_UPDATE,
    KEY_INFO_EXTRACT_COMPLETE,
    KEY_INFO_ERROR,
    KEY_INFO_UPDATE_FIELD,
    KEY_INFO_RESET,

    // Law Dependencies
    LAW_DEPS_REQUEST,
    LAW_DEPS_SUCCESS,
    LAW_DEPS_ERROR,

    // Regulatory Alerts
    REG_ALERTS_REQUEST,
    REG_ALERTS_SUCCESS,
    REG_ALERTS_ERROR,
    REG_ALERT_UPDATE,

    // Workspaces & Folders
    WORKSPACES_REQUEST,
    WORKSPACES_SUCCESS,
    WORKSPACES_FAILURE,
    FOLDERS_REQUEST,
    FOLDERS_SUCCESS,
    FOLDERS_FAILURE,
    SMART_VIEWS_REQUEST,
    SMART_VIEWS_SUCCESS,
    SMART_VIEWS_FAILURE,
    SET_ACTIVE_WORKSPACE,
    SET_ACTIVE_FOLDER,
    SET_ACTIVE_SMART_VIEW,
    CREATE_WORKSPACE_SUCCESS,
    CREATE_FOLDER_SUCCESS,
    CREATE_SMART_VIEW_SUCCESS,
    DELETE_SMART_VIEW_SUCCESS,
    SMART_VIEW_COUNTS_SUCCESS,

    // Monitoring
    SET_ACTIVE_MONITORING_VIEW,
    FETCH_MONITORING_ALERTS_REQUEST,
    FETCH_MONITORING_ALERTS_SUCCESS,
    FETCH_MONITORING_ALERTS_FAILURE,
    FETCH_MONITORING_LIFECYCLE_REQUEST,
    FETCH_MONITORING_LIFECYCLE_SUCCESS,
    FETCH_MONITORING_LIFECYCLE_FAILURE,

} from '../actions/types';

const initialState = {
    // Existing contract state
    contracts: [],
    contractsCache: {},
    contract: null,
    contractContent: null,
    loading: false,
    error: null,
    highlightError: null,
    saveLoading: false,
    saveError: null,
    history: [],
    historyLoading: false,
    historyError: null,
    // Unified activity feed
    activity: [],
    activityLoading: false,
    activityError: null,
    loadingCreate: false,
    errorCreate: null,
    loadingSearch: false,
    errorSearch: null,
    loadingShare: false,
    errorShare: null,
    loadingDelete: false,
    errorDelete: null,
    totalContracts: 0,

    // Tab-specific pagination state
    tabPagination: {
        0: { page: 1, totalContracts: 0 },  // All
        1: { page: 1, totalContracts: 0 },  // Recent
        2: { page: 1, totalContracts: 0 },  // Shared
        3: { page: 1, totalContracts: 0 },  // Drafts
        4: { page: 1, totalContracts: 0 },  // In Review
        5: { page: 1, totalContracts: 0 },  // Pending Signature
        6: { page: 1, totalContracts: 0 },  // To Sign (documents à signer)
        7: { page: 1, totalContracts: 0 },  // Signed
    },
    currentTab: 0,

    // Chat state
    messages: [],
    chatError: null,
    currentConversationId: null,
    creatingConversation: false,
    clearingChat: false,

    // risks
    risks: [],
    loadingRisk: false,
    riskAnalysisError: null,

    clauses: [],
    loadingClause: false,
    clausesError: null,

    suggestedClauses: [],
    loadingSuggestedClause: false,
    suggestedClausesError: null,

    // Key Info
    keyInfo: null,
    loadingKeyInfo: false,
    extractingKeyInfo: false,
    keyInfoError: null,

    // Law Dependencies & Regulatory Alerts
    lawDependencies: [],
    regulatoryAlerts: [],
    loadingLawDeps: false,
    loadingAlerts: false,

    loadingStatus: false,

    loadingFilter: false,
    errorFilter: null,
    filteredContracts: [],

    // Contract Categories
    contractCategories: [],
    loadingCategories: false,
    categoriesError: null,

    // Version restore signal for DocumentEditor
    contentRestored: 0,

    // Workspaces & Folders
    workspaces: [],
    folders: [],
    smartViews: [],
    activeWorkspace: null,
    activeFolder: null,
    activeSmartView: null,
    loadingWorkspaces: false,
    loadingFolders: false,
    loadingSmartViews: false,
    smartViewCounts: {},

    // Monitoring
    activeMonitoringView: null, // 'regulatory_alerts' | 'contract_lifecycle' | null
    monitoringAlerts: [],
    monitoringLifecycle: [],
    loadingMonitoring: false,

};

const contractReducer = (state = initialState, action) => {
    switch (action.type) {
        // Existing contract cases remain unchanged
        case UPDATE_CONTRACT_CONTENT:
            return {
                ...state,
                contractContent: action.payload,
                contract: {
                    ...state.contract,
                    content: action.payload
                }
            };

        case SET_CONTRACT_DATA:
            return {
                ...state,
                contract: action.payload,
                contractContent: action.payload?.content || null
            };

        case RESTORE_CONTRACT_VERSION:
            return {
                ...state,
                restoredContent: action.payload,
                contentRestored: state.contentRestored + 1
            };

        case SET_CONTRACT_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case SET_CONTRACT_ERROR:
            return {
                ...state,
                error: action.payload
            };

        case SET_HIGHLIGHT_ERROR:
            return {
                ...state,
                highlightError: action.payload
            };

        case RESET_CONTRACT:
            return initialState;

        case FETCH_CONTRACT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_CONTRACT_SUCCESS:
            return {
                ...state,
                contract: action.payload,
                contractContent: action.payload.content,
                loading: false
            };

        case FETCH_CONTRACT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case SAVE_CONTRACT_REQUEST:
            return {
                ...state,
                saveLoading: true,
                saveError: null
            };

        case SAVE_CONTRACT_SUCCESS:
            return {
                ...state,
                contract: action.payload,
                saveLoading: false
            };

        case SAVE_CONTRACT_FAILURE:
            return {
                ...state,
                saveLoading: false,
                saveError: action.payload
            };

        case FETCH_CONTRACT_HISTORY_REQUEST:
            return {
                ...state,
                historyLoading: true,
                historyError: null
            };

        case FETCH_CONTRACT_HISTORY_SUCCESS:
            return {
                ...state,
                history: action.payload,
                historyLoading: false
            };

        case FETCH_CONTRACT_HISTORY_FAILURE:
            return {
                ...state,
                historyLoading: false,
                historyError: action.payload
            };

        case ADD_HISTORY_ENTRY:
            const updatedHistory = [...state.history, action.payload]
                .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

            return {
                ...state,
                history: updatedHistory
            };

        case FETCH_CONTRACT_ACTIVITY_REQUEST:
            return {
                ...state,
                activityLoading: true,
                activityError: null
            };

        case FETCH_CONTRACT_ACTIVITY_SUCCESS:
            return {
                ...state,
                activity: action.payload,
                activityLoading: false
            };

        case FETCH_CONTRACT_ACTIVITY_FAILURE:
            return {
                ...state,
                activityLoading: false,
                activityError: action.payload
            };

        case FETCH_CONTRACTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_CONTRACTS_SUCCESS:
            return {
                ...state,
                loading: false,
                contracts: action.payload,
                error: null,
                contractsCache: {
                    ...state.contractsCache,
                    [`${action.meta.offset}_${action.meta.limit}`]: action.payload
                }
            };

        case FETCH_CONTRACTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_CONTRACTS_BY_TAB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_CONTRACTS_BY_TAB_SUCCESS:
            return {
                ...state,
                loading: false,
                contracts: action.payload,
                error: null
            };

        case FETCH_CONTRACTS_BY_TAB_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case SET_TAB_TOTAL_COUNT:
            return {
                ...state,
                tabPagination: {
                    ...state.tabPagination,
                    [action.payload.tab]: {
                        ...state.tabPagination[action.payload.tab],
                        totalContracts: action.payload.totalContracts
                    }
                }
            };

        case SET_CURRENT_TAB:
            return {
                ...state,
                currentTab: action.payload
            };

        case SET_TAB_PAGE:
            return {
                ...state,
                tabPagination: {
                    ...state.tabPagination,
                    [action.payload.tab]: {
                        ...state.tabPagination[action.payload.tab],
                        page: action.payload.page
                    }
                }
            };

        case CREATE_CONTRACT_REQUEST:
            return {
                ...state,
                loadingCreate: true,
                errorCreate: null
            };

        case CREATE_CONTRACT_SUCCESS:
            return {
                ...state,
                loadingCreate: false,
                contracts: [action.payload, ...state.contracts],
                errorCreate: null
            };

        case CREATE_CONTRACT_FAILURE:
            return {
                ...state,
                loadingCreate: false,
                errorCreate: action.payload
            };

        case SEARCH_CONTRACTS_REQUEST:
            return {
                ...state,
                loadingSearch: true,
                errorSearch: null
            };

        case SEARCH_CONTRACTS_SUCCESS:
            return {
                ...state,
                loadingSearch: false,
                contracts: action.payload,
                errorSearch: null
            };

        case SEARCH_CONTRACTS_FAILURE:
            return {
                ...state,
                loadingSearch: false,
                errorSearch: action.payload
            };

        case SHARE_CONTRACT_REQUEST:
            return {
                ...state,
                loadingShare: true,
                errorShare: null
            };

        // In src/redux/reducers/contractReducer.js

        case SHARE_CONTRACT_SUCCESS:
            const { contractId, collaborators } = action.payload;

            // Update the contract in the contracts array
            const updatedContracts = state.contracts.map(contract => {
                if (contract.id === contractId) {
                    // Combine existing collaborators with new ones
                    const existingCollaborators = contract.collaborators || [];
                    const newCollaboratorIds = collaborators.map(c => c.id);

                    // Filter out duplicates (collaborators already in the list)
                    const uniqueExistingCollaborators = existingCollaborators.filter(
                        ec => !newCollaboratorIds.includes(ec.id)
                    );

                    return {
                        ...contract,
                        collaborators: [...uniqueExistingCollaborators, ...collaborators]
                    };
                }
                return contract;
            });

            // Update the filtered contracts array with the same logic
            const updatedFilteredContracts = state.filteredContracts.map(contract => {
                if (contract.id === contractId) {
                    const existingCollaborators = contract.collaborators || [];
                    const newCollaboratorIds = collaborators.map(c => c.id);

                    const uniqueExistingCollaborators = existingCollaborators.filter(
                        ec => !newCollaboratorIds.includes(ec.id)
                    );

                    return {
                        ...contract,
                        collaborators: [...uniqueExistingCollaborators, ...collaborators]
                    };
                }
                return contract;
            });

            // Update the currently selected contract if it matches
            const updatedCurrentContract = state.contract && state.contract.id === contractId
                ? {
                    ...state.contract,
                    collaborators: [
                        ...(state.contract.collaborators || []).filter(
                            ec => !collaborators.map(c => c.id).includes(ec.id)
                        ),
                        ...collaborators
                    ]
                }
                : state.contract;

            return {
                ...state,
                loadingShare: false,
                contracts: updatedContracts,
                filteredContracts: updatedFilteredContracts,
                contract: updatedCurrentContract,
                errorShare: null
            };

        case SHARE_CONTRACT_FAILURE:
            return {
                ...state,
                loadingShare: false,
                errorShare: action.payload
            };

        case DELETE_CONTRACTS_REQUEST:
            return {
                ...state,
                loadingDelete: true,
                errorDelete: null
            };

        case DELETE_CONTRACTS_SUCCESS:
            return {
                ...state,
                loadingDelete: false,
                contractsCache: {},
                contracts: state.contracts.filter(contract => !action.payload.contractIds.includes(contract.id)),
                errorDelete: null
            };

        case DELETE_CONTRACTS_FAILURE:
            return {
                ...state,
                loadingDelete: false,
                errorDelete: action.payload
            };

        // Chat message cases
        case CONTRACT_MESSAGE_CLEAR:
            return {
                ...state,
                messages: [],
                chatError: null
            };

        case CONTRACT_MESSAGE_SET:
            return {
                ...state,
                messages: (action.payload || []).map(msg => ({
                    id: msg.id || crypto.randomUUID(),
                    text: msg.content,
                    content: msg.content,
                    sender: msg.role === "assistant" ? "bot" : "user",
                    role: msg.role,
                    status: msg.status || 'SUCCESS',
                    is_streaming: false,
                    sources: msg.sources || [],
                    tool_executions: msg.tool_executions || [],
                    activeTools: [],
                    completedTools: [],
                    node_executions: msg.node_executions || [],
                    execution_plan: msg.execution_plan || null,
                    metadata: msg.metadata || null,
                    created_at: msg.created_at,
                })),
                chatError: null
            };

        case CONTRACT_MESSAGE_ADD_USER: {
            const newMessage = {
                id: crypto.randomUUID(),
                text: action.payload.content,
                sender: "user",
                status: action.payload.status,
                created_at: action.payload.created_at
            };

            return {
                ...state,
                messages: [...state.messages, newMessage],
                chatError: null
            };
        }

        case CONTRACT_MESSAGE_STREAM_UPDATE: {
            const incomingMsg = action.payload;

            if (!incomingMsg || typeof incomingMsg !== "object") {
                return {
                    ...state,
                    chatError: "Invalid message format received"
                };
            }

            const updatedMessages = [...state.messages];

            // Find the last bot message
            let lastAssistantIndex = -1;
            for (let i = updatedMessages.length - 1; i >= 0; i--) {
                if (updatedMessages[i].sender === "bot") {
                    lastAssistantIndex = i;
                    break;
                }
            }

            // Determine if we need to update the existing message or append a new one
            if (lastAssistantIndex !== -1 && updatedMessages[lastAssistantIndex].id === incomingMsg.id) {
                updatedMessages[lastAssistantIndex] = {
                    ...updatedMessages[lastAssistantIndex],
                    text: incomingMsg.content,
                    content: incomingMsg.content,
                    status: incomingMsg.status
                };
            } else {
                updatedMessages.push({
                    id: incomingMsg.id,
                    text: incomingMsg.content,
                    content: incomingMsg.content,
                    sender: "bot",
                    status: incomingMsg.status,
                    is_streaming: true,
                    sources: [],
                    tool_executions: [],
                    activeTools: [],
                    completedTools: [],
                    node_executions: [],
                    execution_plan: null,
                    metadata: null,
                    created_at: incomingMsg.created_at
                });
            }

            return {
                ...state,
                messages: updatedMessages,
                chatError: null
            };
        }


        case CONTRACT_MESSAGE_STREAM_DONE: {
            const incomingMsg = action.payload;

            if (!incomingMsg || typeof incomingMsg !== "object") {
                return {
                    ...state,
                    chatError: "Invalid message format received"
                };
            }

            const updatedMessages = [...state.messages];

            // Find the last bot message
            let lastAssistantIndex = -1;
            for (let i = updatedMessages.length - 1; i >= 0; i--) {
                if (updatedMessages[i].sender === "bot") {
                    lastAssistantIndex = i;
                    break;
                }
            }

            // Update the existing message or append a new one
            if (lastAssistantIndex !== -1 && updatedMessages[lastAssistantIndex].id === incomingMsg.id) {
                updatedMessages[lastAssistantIndex] = {
                    ...updatedMessages[lastAssistantIndex],
                    text: incomingMsg.content,
                    content: incomingMsg.content,
                    status: incomingMsg.status,
                    is_streaming: false,
                };
            } else {
                updatedMessages.push({
                    id: incomingMsg.id,
                    text: incomingMsg.content,
                    content: incomingMsg.content,
                    sender: "bot",
                    status: incomingMsg.status,
                    is_streaming: false,
                    created_at: incomingMsg.created_at
                });
            }

            return {
                ...state,
                messages: updatedMessages,
                chatError: null
            };
        }

        case CONTRACT_MESSAGE_ERROR:
            return {
                ...state,
                chatError: action.payload
            };

        // Rich execution tracking cases
        case CONTRACT_CHAT_UPDATE_MESSAGE:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.id ? { ...msg, ...action.payload } : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_TOOLS:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? {
                            ...msg,
                            ...(action.payload.tool_executions !== undefined && { tool_executions: action.payload.tool_executions }),
                            ...(action.payload.activeTools !== undefined && { activeTools: action.payload.activeTools }),
                            ...(action.payload.completedTools !== undefined && { completedTools: action.payload.completedTools }),
                            ...(action.payload.workflowProgress !== undefined && { workflowProgress: action.payload.workflowProgress }),
                            ...(action.payload.currentThought !== undefined && { currentThought: action.payload.currentThought }),
                        }
                        : msg
                ),
            };

        case CONTRACT_CHAT_ADD_TOOL_EXECUTION:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? {
                            ...msg,
                            tool_executions: [
                                ...(msg.tool_executions || []),
                                action.payload.toolExecution,
                            ],
                        }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_NODE_EXECUTION:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? { ...msg, node_executions: action.payload.node_executions }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_PLAN:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? { ...msg, execution_plan: action.payload.execution_plan }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_STEP_EXECUTION:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? {
                            ...msg,
                            execution_plan: msg.execution_plan
                                ? {
                                    ...msg.execution_plan,
                                    steps: msg.execution_plan.steps.map((step) =>
                                        step.step_id === action.payload.step_id
                                            ? { ...step, ...action.payload.updates }
                                            : step
                                    ),
                                }
                                : msg.execution_plan,
                        }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_SOURCES:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? { ...msg, sources: action.payload.sources }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_METADATA:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? { ...msg, metadata: action.payload.metadata }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_EDITS:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? { ...msg, document_edits: action.payload.edits }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_EDIT_STATUS:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? {
                            ...msg,
                            document_edits: (msg.document_edits || []).map((edit) =>
                                edit.edit_id === action.payload.editId
                                    ? { ...edit, status: action.payload.status }
                                    : edit
                            ),
                        }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTIONS:
            return {
                ...state,
                messages: state.messages.map((msg) => {
                    if (msg.id !== action.payload.messageId) return msg;
                    // Final batch arrives after section-by-section progressive updates.
                    // Merge by suggestion_id, preserving any per-suggestion status the
                    // user may have set (applied/rejected) before final arrived.
                    const existing = msg.review_suggestions || [];
                    const existingById = new Map(existing.map(s => [s.suggestion_id, s]));
                    const merged = (action.payload.suggestions || []).map(s => {
                        const prior = existingById.get(s.suggestion_id);
                        return prior ? { ...s, status: prior.status || s.status } : s;
                    });
                    return {
                        ...msg,
                        review_suggestions: merged,
                        review_summary: action.payload.review_summary || msg.review_summary || null,
                    };
                }),
            };

        case CONTRACT_CHAT_UPDATE_REVIEW_SUGGESTION_STATUS:
            return {
                ...state,
                messages: state.messages.map((msg) =>
                    msg.id === action.payload.messageId
                        ? {
                            ...msg,
                            review_suggestions: (msg.review_suggestions || []).map((s) =>
                                s.suggestion_id === action.payload.suggestionId
                                    ? {
                                        ...s,
                                        status: action.payload.status,
                                        // mark_id may be sent alongside the status update when
                                        // the suggestion was just auto-applied to the editor.
                                        ...(action.payload.mark_id
                                            ? { mark_id: action.payload.mark_id }
                                            : {}),
                                    }
                                    : s
                            ),
                        }
                        : msg
                ),
            };

        case CONTRACT_CHAT_UPDATE_REVIEW_PROGRESS:
            return {
                ...state,
                messages: state.messages.map((msg) => {
                    if (msg.id !== action.payload.messageId) return msg;
                    const update = action.payload.update;
                    const progress = msg.review_progress || { sections: {}, totalSections: 0 };
                    if (update.type === 'section_start') {
                        return {
                            ...msg,
                            review_progress: {
                                ...progress,
                                totalSections: update.total_sections || progress.totalSections,
                                sections: {
                                    ...progress.sections,
                                    [update.section_id]: {
                                        section_id: update.section_id,
                                        title: update.section_title,
                                        index: update.section_index,
                                        status: 'in_progress',
                                    },
                                },
                            },
                        };
                    }
                    if (update.type === 'section_complete') {
                        const prior = progress.sections[update.section_id] || {};
                        // Merge incremental suggestions in (final batch arrives later;
                        // both paths dedupe in the reducer by suggestion_id).
                        const existing = msg.review_suggestions || [];
                        const existingIds = new Set(existing.map(s => s.suggestion_id));
                        const incoming = (update.suggestions || []).filter(
                            s => !existingIds.has(s.suggestion_id)
                        );
                        return {
                            ...msg,
                            review_suggestions: [...existing, ...incoming],
                            review_progress: {
                                ...progress,
                                sections: {
                                    ...progress.sections,
                                    [update.section_id]: {
                                        ...prior,
                                        section_id: update.section_id,
                                        title: update.section_title || prior.title,
                                        status: 'complete',
                                        suggestion_count: update.suggestion_count || 0,
                                    },
                                },
                            },
                        };
                    }
                    return msg;
                }),
            };

        // Conversation management cases
        case CREATE_CONTRACT_CONVERSATION_REQUEST:
            return {
                ...state,
                creatingConversation: true,
                chatError: null
            };

        case CREATE_CONTRACT_CONVERSATION_SUCCESS:
            return {
                ...state,
                currentConversationId: action.payload,
                creatingConversation: false
            };

        case CREATE_CONTRACT_CONVERSATION_FAILURE:
            return {
                ...state,
                creatingConversation: false,
                chatError: action.payload
            };

        case CLEAR_CHAT_REQUEST:
            return {
                ...state,
                clearingChat: true,
                chatError: null
            };

        case CLEAR_CHAT_SUCCESS:
            return {
                ...state,
                clearingChat: false,
                messages: []
            };

        case CLEAR_CHAT_FAILURE:
            return {
                ...state,
                clearingChat: false,
                chatError: action.payload
            };


        case RISK_ANALYSIS_REQUEST:
            return {
                ...state,
                loadingRisk: true,
                riskAnalysisError: null
            };

        case RISK_ANALYSIS_RESET:
            return {
                ...state,
                risks: [],
                riskAnalysisError: null
            };

        case RISK_ANALYSIS_ADD: {
            const updatedRisk = action.payload;
            const riskIndex = state.risks.findIndex(risk => risk.risk_id === updatedRisk.risk_id);
            if (riskIndex !== -1) {
                // Merge new data with the existing risk, but preserve sources if they exist
                const existingRisk = state.risks[riskIndex];
                const mergedRisk = {
                    ...existingRisk,
                    ...updatedRisk,
                    // Preserve sources from existing risk if new payload doesn't have sources or has empty sources
                    sources: updatedRisk.sources && updatedRisk.sources.length > 0 
                        ? updatedRisk.sources 
                        : (existingRisk.sources || [])
                };
                return {
                    ...state,
                    risks: [
                        ...state.risks.slice(0, riskIndex),
                        mergedRisk,
                        ...state.risks.slice(riskIndex + 1)
                    ]
                };
            }
            // If no risk exists with that id, add it to the list
            return {
                ...state,
                risks: [...state.risks, updatedRisk]
            };
        }

        case RISK_ANALYSIS_ERROR:
            return {
                ...state,
                riskAnalysisError: action.payload
            };

        case RISK_ANALYSIS_COMPLETE:
            return {
                ...state,
                loadingRisk: false
            };



        // clauses identification
        case CLAUSES_REQUEST:
            return {
                ...state,
                loadingClause: true,
                clausesError: null
            };

        case CLAUSES_RESET:
            return {
                ...state,
                clauses: [],
                clausesError: null
            };

        case CLAUSES_ADD:
            return {
                ...state,
                clauses: [...state.clauses, action.payload]
            };

        case CLAUSES_ERROR:
            return {
                ...state,
                clausesError: action.payload
            };

        case CLAUSES_COMPLETE:
            return {
                ...state,
                loadingClause: false
            };

        case SUGGESTED_CLAUSES_REQUEST:
            return {
                ...state,
                loadingSuggestedClause: true,
                suggestedClausesError: null
            };

        case SUGGESTED_CLAUSES_RESET:
            return {
                ...state,
                suggestedClauses: [],
                suggestedClausesError: null
            };

        case SUGGESTED_CLAUSES_ADD:
            return {
                ...state,
                suggestedClauses: [...state.suggestedClauses, action.payload]
            };

        case SUGGESTED_CLAUSES_ERROR:
            return {
                ...state,
                suggestedClausesError: action.payload
            };

        case SUGGESTED_CLAUSES_COMPLETE:
            return {
                ...state,
                loadingSuggestedClause: false
            };


        // Add a case in your reducer to handle the new action type
        case SET_CURRENT_CONVERSATION_ID:
            return {
                ...state,
                currentConversationId: action.payload
            };

        // Add these cases to the contractReducer switch statement
        case UPDATE_CONTRACT_STATUS:
            return {
                ...state,
                loadingStatus: true,
                error: null
            };

        case UPDATE_CONTRACT_STATUS_SUCCESS:
            return {
                ...state,
                contract: state.contract?.id === action.payload.contractId
                    ? { ...state.contract, status: action.payload.status }
                    : state.contract,
                contracts: (state.contracts || []).map(c =>
                    c.id === action.payload.contractId
                        ? { ...c, status: action.payload.status }
                        : c
                ),
                loadingStatus: false,
                error: null
            };

        case UPDATE_CONTRACT_STATUS_FAILURE:
            return {
                ...state,
                loadingStatus: false,
                error: action.payload
            };

        case UPDATE_CONTRACT_COUNTRY_SUCCESS:
            return {
                ...state,
                contract: state.contract?.id === action.payload.contractId
                    ? { ...state.contract, country: action.payload.country }
                    : state.contract,
                contracts: (state.contracts || []).map(c =>
                    c.id === action.payload.contractId
                        ? { ...c, country: action.payload.country }
                        : c
                ),
            };

        case REORDER_KANBAN_CONTRACTS: {
            const updateMap = new Map(
                action.payload.map(u => [u.id, u])
            );
            return {
                ...state,
                contracts: (state.contracts || []).map(c => {
                    const upd = updateMap.get(c.id);
                    if (!upd) return c;
                    return {
                        ...c,
                        kanban_position: upd.kanban_position,
                        ...(upd.status !== undefined ? { status: upd.status } : {}),
                    };
                }),
            };
        }

        case FILTER_CONTRACTS_REQUEST:
            return {
                ...state,
                loadingFilter: true,
                errorFilter: null
            };

        case FILTER_CONTRACTS_SUCCESS:
            return {
                ...state,
                loadingFilter: false,
                filteredContracts: action.payload,
                errorFilter: null
            };

        case FILTER_CONTRACTS_FAILURE:
            return {
                ...state,
                loadingFilter: false,
                errorFilter: action.payload
            };

        case UPDATE_CONTRACT_OPTIMISTIC:
            return {
                ...state,
                contracts: state.contracts.map(contract =>
                    contract.id === action.payload.id
                        ? { ...contract, ...action.payload.contractData }
                        : contract
                ),
                // If the contract detail is loaded, update it too
                contract: state.contract && state.contract.id === action.payload.id
                    ? { ...state.contract, ...action.payload.contractData }
                    : state.contract,
                // Update filtered contracts if they exist
                filteredContracts: state.filteredContracts.map(contract =>
                    contract.id === action.payload.id
                        ? { ...contract, ...action.payload.contractData }
                        : contract
                )
            };

        // Contract Categories
        case FETCH_CONTRACT_CATEGORIES_REQUEST:
            return {
                ...state,
                loadingCategories: true,
                categoriesError: null
            };

        case FETCH_CONTRACT_CATEGORIES_SUCCESS:
            return {
                ...state,
                contractCategories: action.payload,
                loadingCategories: false,
                categoriesError: null
            };

        case FETCH_CONTRACT_CATEGORIES_FAILURE:
            return {
                ...state,
                loadingCategories: false,
                categoriesError: action.payload
            };

        // ── Key Info ──────────────────────────────────────────────

        case KEY_INFO_REQUEST:
            return { ...state, loadingKeyInfo: true, keyInfoError: null };

        case KEY_INFO_FETCH_SUCCESS:
            return { ...state, keyInfo: action.payload, loadingKeyInfo: false };

        case KEY_INFO_EXTRACT_REQUEST:
            return { ...state, extractingKeyInfo: true, keyInfoError: null };

        case KEY_INFO_EXTRACT_UPDATE:
            return { ...state, keyInfo: action.payload };

        case KEY_INFO_EXTRACT_COMPLETE:
            return { ...state, extractingKeyInfo: false };

        case KEY_INFO_ERROR:
            return { ...state, loadingKeyInfo: false, extractingKeyInfo: false, keyInfoError: action.payload };

        case KEY_INFO_UPDATE_FIELD:
            return {
                ...state,
                keyInfo: state.keyInfo ? { ...state.keyInfo, ...action.payload } : action.payload,
            };

        case KEY_INFO_RESET:
            return { ...state, keyInfo: null, loadingKeyInfo: false, extractingKeyInfo: false, keyInfoError: null };

        // ── Law Dependencies ──────────────────────────────────────────────

        case LAW_DEPS_REQUEST:
            return { ...state, loadingLawDeps: true };

        case LAW_DEPS_SUCCESS:
            return { ...state, lawDependencies: action.payload, loadingLawDeps: false };

        case LAW_DEPS_ERROR:
            return { ...state, loadingLawDeps: false };

        // ── Regulatory Alerts ─────────────────────────────────────────────

        case REG_ALERTS_REQUEST:
            return { ...state, loadingAlerts: true };

        case REG_ALERTS_SUCCESS:
            return { ...state, regulatoryAlerts: action.payload, loadingAlerts: false };

        case REG_ALERTS_ERROR:
            return { ...state, loadingAlerts: false };

        case REG_ALERT_UPDATE:
            return {
                ...state,
                regulatoryAlerts: state.regulatoryAlerts.map(alert =>
                    alert.id === action.payload.id ? { ...alert, ...action.payload } : alert
                ),
            };

        // ── Workspaces & Folders ──────────────────────────────────────────

        case WORKSPACES_REQUEST:
            return { ...state, loadingWorkspaces: true };

        case WORKSPACES_SUCCESS:
            return { ...state, workspaces: action.payload, loadingWorkspaces: false };

        case WORKSPACES_FAILURE:
            return { ...state, loadingWorkspaces: false };

        case FOLDERS_REQUEST:
            return { ...state, loadingFolders: true };

        case FOLDERS_SUCCESS:
            return { ...state, folders: action.payload, loadingFolders: false };

        case FOLDERS_FAILURE:
            return { ...state, loadingFolders: false };

        case SMART_VIEWS_REQUEST:
            return { ...state, loadingSmartViews: true };

        case SMART_VIEWS_SUCCESS:
            return { ...state, smartViews: action.payload, loadingSmartViews: false };

        case SMART_VIEWS_FAILURE:
            return { ...state, loadingSmartViews: false };

        case SET_ACTIVE_WORKSPACE:
            return { ...state, activeWorkspace: action.payload, activeFolder: null };

        case SET_ACTIVE_FOLDER:
            return { ...state, activeFolder: action.payload };

        case SET_ACTIVE_SMART_VIEW:
            return { ...state, activeSmartView: action.payload, activeSmartViewKey: action.meta?.filterKey || null };

        case CREATE_WORKSPACE_SUCCESS:
            return { ...state, workspaces: [...state.workspaces, action.payload] };

        case CREATE_FOLDER_SUCCESS:
            return { ...state, folders: [...state.folders, action.payload] };

        case CREATE_SMART_VIEW_SUCCESS:
            return { ...state, smartViews: [...state.smartViews, action.payload] };

        case DELETE_SMART_VIEW_SUCCESS:
            return { ...state, smartViews: state.smartViews.filter(v => v.id !== action.payload) };

        case SMART_VIEW_COUNTS_SUCCESS:
            return { ...state, smartViewCounts: action.payload };

        // ── Monitoring ──────────────────────────────────────────────
        case SET_ACTIVE_MONITORING_VIEW:
            return { ...state, activeMonitoringView: action.payload };

        case FETCH_MONITORING_ALERTS_REQUEST:
            return { ...state, loadingMonitoring: true };
        case FETCH_MONITORING_ALERTS_SUCCESS:
            return { ...state, loadingMonitoring: false, monitoringAlerts: action.payload };
        case FETCH_MONITORING_ALERTS_FAILURE:
            return { ...state, loadingMonitoring: false };

        case FETCH_MONITORING_LIFECYCLE_REQUEST:
            return { ...state, loadingMonitoring: true };
        case FETCH_MONITORING_LIFECYCLE_SUCCESS:
            return { ...state, loadingMonitoring: false, monitoringLifecycle: action.payload };
        case FETCH_MONITORING_LIFECYCLE_FAILURE:
            return { ...state, loadingMonitoring: false };

        default:
            return state;
    }
};

export default contractReducer;